module.exports = __webpack_public_path__ + "img/52exp.6c87b752.jpg";